var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "video-courses" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-10" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/video-courses" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "video_lectures.sub_header.video_courses"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/video-lectures" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "video_lectures.sub_header.video_lectures"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 hidden-xs-down" }, [
            _c(
              "div",
              { staticClass: "sub-header-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "btn btn-primary new-video-course-btn float-right",
                    attrs: { to: "/new-video-course" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("video_lectures.sub_header.new_video_course")
                        ) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _c(
              "div",
              { staticClass: "row list-group" },
              [
                _vm.videoCourseList.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("video_lectures.no_course")
                            )
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.videoCourseList, function(videoCourse) {
                      return _c(
                        "div",
                        { key: videoCourse.id, staticClass: "list-group-item" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: "/video-courses/" + videoCourse.id }
                            },
                            [
                              _c("VideoCourseItem", {
                                attrs: { course: videoCourse }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ml-auto" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    to:
                                      "/video-courses/" +
                                      videoCourse.id +
                                      "/edit"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("common.edit")) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v("\n                    \n          "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.showUpdateCourseLecturesShareLevelModal(
                                        videoCourse.id,
                                        _vm.publicShareLevel
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.video_lectures.share_level.public"
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.showUpdateCourseLecturesShareLevelModal(
                                        videoCourse.id,
                                        _vm.privateShareLevel
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.video_lectures.share_level.private"
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal",
            attrs: {
              id: "make-video-course-lectures-public-modal",
              "hide-header": true,
              "close-title": _vm.$t("common.cancel"),
              "ok-title": _vm.$t("common.confirm")
            },
            on: {
              ok: function($event) {
                return _vm.updateCourseLecturesShareLevel(_vm.publicShareLevel)
              },
              cancel: function($event) {
                _vm.courseIdToUpdateShareLevel = null
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "video_lectures.modals.make_course_lectures_public.message"
                  )
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal",
            attrs: {
              id: "make-video-course-lectures-private-modal",
              "hide-header": true,
              "close-title": _vm.$t("common.cancel"),
              "ok-title": _vm.$t("common.confirm")
            },
            on: {
              ok: function($event) {
                return _vm.updateCourseLecturesShareLevel(_vm.privateShareLevel)
              },
              cancel: function($event) {
                _vm.courseIdToUpdateShareLevel = null
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "video_lectures.modals.make_course_lectures_private.message"
                  )
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-084694d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-084694d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-courses/views/VideoCourseList.vue
// module id = TX5r
// module chunks = 1